import { useCallback } from 'react';

import { formatEurAmount } from '@/core/billing/format-eur';
import { useLocale } from '@/core/providers/dictionary-provider';

/** {@link formatEurAmount} bound to the app locale. */
export function useFormatEur(): (amount: number) => string {
  const locale = useLocale();
  return useCallback(
    (amount: number) => formatEurAmount(amount, locale),
    [locale],
  );
}
